import React from 'react';
import { ThemeProvider } from 'styled-components';
import PropTypes from 'prop-types';
import Theme from './Theme';
import GlobalStyles from './GlobalStyles';

const BrandThemeProvider = ({ children }) => (
  <ThemeProvider theme={Theme}>
    <>
      <GlobalStyles />
      {children}
    </>
  </ThemeProvider>
);

BrandThemeProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default BrandThemeProvider;
